import React from 'react';

export const LongDashIcon = () => (
  <svg
    width="30"
    height="3"
    viewBox="0 0 30 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="29"
      y1="1.5"
      x2="1"
      y2="1.5"
      stroke="#ABABAB"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const GoogleIcon = ({ size = 17 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.97849 3.519C10.4655 3.519 11.4685 4.16131 12.0405 4.69803L14.2753 2.51594C12.9027 1.24012 11.1166 0.457031 8.97849 0.457031C5.88133 0.457031 3.20651 2.23438 1.9043 4.82121L4.46473 6.80973C5.10704 4.9004 6.88439 3.519 8.97849 3.519Z"
      fill="#EA4335"
    />
    <path
      d="M16.5806 8.55256C16.5806 7.90146 16.5278 7.42632 16.4135 6.93359H8.97852V9.87238H13.3427C13.2547 10.6027 12.7796 11.7025 11.7237 12.4416L14.2226 14.3773C15.7184 12.9959 16.5806 10.9634 16.5806 8.55256Z"
      fill="#4285F4"
    />
    <path
      d="M4.47349 9.94118C4.30631 9.44846 4.20952 8.92053 4.20952 8.37501C4.20952 7.82949 4.30631 7.30156 4.46469 6.80883L1.90425 4.82031C1.36753 5.89376 1.05957 7.09919 1.05957 8.37501C1.05957 9.65083 1.36753 10.8563 1.90425 11.9297L4.47349 9.94118Z"
      fill="#FBBC05"
    />
    <path
      d="M8.97848 16.2941C11.1166 16.2941 12.9115 15.5902 14.2225 14.376L11.7237 12.4403C11.055 12.9066 10.1575 13.2321 8.97848 13.2321C6.88438 13.2321 5.10703 11.8507 4.47352 9.94141L1.91309 11.9299C3.2153 14.5168 5.88132 16.2941 8.97848 16.2941Z"
      fill="#34A853"
    />
  </svg>
);

export const GoogleFillIcon = ({ color = '#000000' }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.05342 6.25866C3.74676 4.87803 4.81039 3.71742 6.12544 2.90655C7.44049 2.09568 8.95513 1.66651 10.5001 1.66699C12.7459 1.66699 14.6326 2.49199 16.0751 3.83783L13.6859 6.22783C12.8217 5.40199 11.7234 4.98116 10.5001 4.98116C8.32925 4.98116 6.49175 6.44783 5.83758 8.41699C5.67092 8.91699 5.57592 9.45033 5.57592 10.0003C5.57592 10.5503 5.67092 11.0837 5.83758 11.5837C6.49258 13.5537 8.32925 15.0195 10.5001 15.0195C11.6209 15.0195 12.5751 14.7237 13.3217 14.2237C13.7546 13.9387 14.1252 13.5688 14.4111 13.1366C14.697 12.7043 14.8922 12.2185 14.9851 11.7087H10.5001V8.48533H18.3484C18.4467 9.03033 18.5001 9.59866 18.5001 10.1895C18.5001 12.7278 17.5917 14.8645 16.0151 16.3145C14.6367 17.5878 12.7501 18.3337 10.5001 18.3337C9.40561 18.3341 8.32178 18.1188 7.31054 17.7002C6.29929 17.2816 5.38046 16.6678 4.60655 15.8939C3.83264 15.12 3.21883 14.2011 2.80019 13.1899C2.38156 12.1786 2.16631 11.0948 2.16675 10.0003C2.16675 8.65533 2.48842 7.38366 3.05342 6.25866Z"
      fill={color}
    />
  </svg>
);

export const LinkedinIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.874023 8.37573C0.874023 3.74994 4.62397 0 9.24976 0C13.8755 0 17.6255 3.74994 17.6255 8.37573C17.6255 13.0015 13.8755 16.7515 9.24976 16.7515C4.62397 16.7515 0.874023 13.0015 0.874023 8.37573Z"
      fill="#0077B5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.91858 5.17259C6.91858 5.72019 6.50639 6.15836 5.84454 6.15836H5.83241C5.19517 6.15836 4.7832 5.72019 4.7832 5.17259C4.7832 4.61341 5.20772 4.1875 5.85705 4.1875C6.50639 4.1875 6.90626 4.61341 6.91858 5.17259ZM6.79364 6.93648V12.6396H4.89552V6.93648H6.79364ZM13.6388 12.6397L13.6389 9.36978C13.6389 7.61804 12.7025 6.80275 11.4535 6.80275C10.4457 6.80275 9.99448 7.35629 9.74255 7.74461V6.93682H7.8442C7.86922 7.47197 7.8442 12.6399 7.8442 12.6399H9.74255V9.45483C9.74255 9.28438 9.75487 9.11435 9.80506 8.99232C9.94225 8.65181 10.2546 8.29926 10.779 8.29926C11.4661 8.29926 11.7408 8.82221 11.7408 9.5886V12.6397H13.6388Z"
      fill="white"
    />
  </svg>
);

export const LinkedinFillIcon = ({ color = '#000000' }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.28328 4.16652C6.28306 4.60855 6.10726 5.03239 5.79454 5.34479C5.48182 5.6572 5.05781 5.83258 4.61578 5.83236C4.17376 5.83214 3.74992 5.65633 3.43752 5.34361C3.12511 5.0309 2.94973 4.60688 2.94995 4.16486C2.95017 3.72283 3.12598 3.29899 3.4387 2.98659C3.75141 2.67419 4.17542 2.4988 4.61745 2.49902C5.05948 2.49924 5.48331 2.67505 5.79572 2.98777C6.10812 3.30049 6.28351 3.7245 6.28328 4.16652ZM6.33328 7.06652H2.99995V17.4999H6.33328V7.06652ZM11.6 7.06652H8.28328V17.4999H11.5666V12.0249C11.5666 8.97486 15.5416 8.69152 15.5416 12.0249V17.4999H18.8333V10.8915C18.8333 5.74986 12.95 5.94152 11.5666 8.46652L11.6 7.06652Z"
      fill={color}
    />
  </svg>
);

export const FacebookIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7301 21V14.034H18.0631L18.4121 11.326H15.7301V9.598C15.7301 8.814 15.9481 8.279 17.0721 8.279H18.5061V5.857C17.8119 5.78334 17.1142 5.74762 16.4161 5.75C14.3491 5.75 12.9341 7.012 12.9341 9.33V11.326H10.5961V14.034H12.9341V21H4.32812C4.06291 21 3.80855 20.8946 3.62102 20.7071C3.43348 20.5196 3.32813 20.2652 3.32812 20V4C3.32812 3.73478 3.43348 3.48043 3.62102 3.29289C3.80855 3.10536 4.06291 3 4.32812 3H20.3281C20.5933 3 20.8477 3.10536 21.0352 3.29289C21.2228 3.48043 21.3281 3.73478 21.3281 4V20C21.3281 20.2652 21.2228 20.5196 21.0352 20.7071C20.8477 20.8946 20.5933 21 20.3281 21H15.7301Z"
      fill="#3B5998"
    />
  </svg>
);

export const FacebookButtonIcon = ({ size = 25 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="translate(0.5 0.5)"
      fill="#1877F2"
    />
    <path
      d="M24 12.5694C24 6.21811 18.8513 1.06939 12.5 1.06939C6.14872 1.06939 1 6.21811 1 12.5694C1 18.3094 5.20538 23.067 10.7031 23.9297V15.8936H7.7832V12.5694H10.7031V10.0358C10.7031 7.15361 12.42 5.56158 15.0468 5.56158C16.305 5.56158 17.6211 5.78619 17.6211 5.78619V8.61627H16.171C14.7424 8.61627 14.2969 9.50273 14.2969 10.4122V12.5694H17.4863L16.9765 15.8936H14.2969V23.9297C19.7946 23.067 24 18.3094 24 12.5694Z"
      fill="white"
    />
  </svg>
);

export const FacebookFillIcon = ({ color = '#000000' }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1666 11.2503H14.2499L15.0833 7.91699H12.1666V6.25033C12.1666 5.39199 12.1666 4.58366 13.8333 4.58366H15.0833V1.78366C14.8116 1.74783 13.7858 1.66699 12.7024 1.66699C10.4399 1.66699 8.83325 3.04783 8.83325 5.58366V7.91699H6.33325V11.2503H8.83325V18.3337H12.1666V11.2503Z"
      fill={color}
    />
  </svg>
);

export const SsoBriefIcon = ({ size = 17 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.91634 3.70768V1.70768C4.91634 1.53087 4.98658 1.3613 5.1116 1.23628C5.23663 1.11125 5.4062 1.04102 5.58301 1.04102H10.9163C11.0932 1.04102 11.2627 1.11125 11.3877 1.23628C11.5128 1.3613 11.583 1.53087 11.583 1.70768V3.70768H14.2497C14.4265 3.70768 14.5961 3.77792 14.7211 3.90294C14.8461 4.02797 14.9163 4.19754 14.9163 4.37435V13.7077C14.9163 13.8845 14.8461 14.0541 14.7211 14.1791C14.5961 14.3041 14.4265 14.3743 14.2497 14.3743H2.24967C2.07286 14.3743 1.90329 14.3041 1.77827 14.1791C1.65325 14.0541 1.58301 13.8845 1.58301 13.7077V4.37435C1.58301 4.19754 1.65325 4.02797 1.77827 3.90294C1.90329 3.77792 2.07286 3.70768 2.24967 3.70768H4.91634ZM2.91634 11.041V13.041H13.583V11.041H2.91634ZM2.91634 9.70768H13.583V5.04102H2.91634V9.70768ZM6.24967 2.37435V3.70768H10.2497V2.37435H6.24967ZM7.58301 7.70768H8.91634V9.04102H7.58301V7.70768Z"
      fill="#2E425A"
    />
  </svg>
);

export const KeyIcon = ({ color = '#FFFFFF' }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.678 8.63781L12.8725 3.44336L13.8082 4.37914L12.8725 5.31559L14.5097 6.95287L13.574 7.88932L11.936 6.25137L11.0002 7.18715L12.4039 8.59082L11.4681 9.52727L10.0644 8.12293L8.61379 9.57359C9.06411 10.2579 9.24471 11.0849 9.12067 11.8946C8.99663 12.7043 8.57676 13.4393 7.94224 13.9574C7.30772 14.4756 6.50363 14.74 5.68545 14.6996C4.86726 14.6593 4.0931 14.317 3.51265 13.739C2.93094 13.1594 2.58549 12.3843 2.54341 11.5643C2.50134 10.7443 2.76566 9.93788 3.285 9.30187C3.80433 8.66586 4.54159 8.24566 5.35348 8.12293C6.16536 8.0002 6.99388 8.18372 7.678 8.63781ZM7.25644 12.8025C7.44923 12.6202 7.60351 12.401 7.71015 12.158C7.8168 11.915 7.87365 11.6531 7.87734 11.3877C7.88103 11.1224 7.83148 10.859 7.73164 10.6131C7.63179 10.3672 7.48367 10.1439 7.29602 9.95624C7.10837 9.76859 6.88501 9.62047 6.63914 9.52062C6.39327 9.42078 6.12987 9.37123 5.86453 9.37492C5.59918 9.37861 5.33727 9.43546 5.09426 9.54211C4.85126 9.64875 4.63211 9.80303 4.44975 9.99582C4.0881 10.3703 3.88798 10.8718 3.8925 11.3924C3.89703 11.9129 4.10583 12.4109 4.47394 12.779C4.84205 13.1471 5.34001 13.3559 5.86057 13.3604C6.38113 13.3649 6.88265 13.1648 7.2571 12.8032L7.25644 12.8025Z"
      fill={color}
    />
  </svg>
);

export const BackArrow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.871 5.24952H12V6.74952H2.871L6.894 10.7725L5.8335 11.833L0 5.99952L5.8335 0.166016L6.894 1.22652L2.871 5.24952Z"
      fill="#484848"
    />
  </svg>
);

export const ZuddlLogo = ({
  width = 88,
  height = 26,
  iconFill = 'black',
}: {
  width?: number;
  height?: number;
  iconFill?: 'black' | 'white';
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 102 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.2509 12.1228V0.0166016H67.2462C67.2462 0.0166016 67.3148 14.9436 67.1945 22.3206C67.0213 27.7327 62.2363 31.7826 56.8114 31.9891C50.9545 32.2135 47.1861 28.939 45.9097 25.6275C44.1638 21.1107 44.6825 16.8712 47.8443 13.1143C50.5044 9.91068 56.7416 8.30708 61.2509 12.1228ZM61.0777 20.9294C61.0777 17.9827 59.0396 15.8966 56.1893 15.8798C53.2861 15.863 51.1097 18.0175 51.0928 20.9126C51.076 23.8078 53.2344 26.0139 56.1027 26.0487C59.0046 26.0607 61.0957 23.9062 61.0777 20.9235V20.9294Z"
      fill={iconFill}
    />
    <path
      d="M86.4598 12.1506V0H92.5286V1.06827C92.5286 7.84277 92.5454 14.5981 92.5286 21.3726C92.5117 27.2541 87.8988 31.7659 81.9901 31.9725C75.6663 32.1969 71.5551 28.2154 70.5012 23.6651C69.1356 17.8041 72.1591 11.9274 77.5156 10.3418C80.6895 9.41035 83.7299 9.70323 86.4598 12.1506ZM76.4062 20.9069C76.3883 23.8547 78.4962 26.0081 81.3982 26.043C84.2664 26.0777 86.4262 23.8715 86.4093 20.9416C86.3925 18.0117 84.3182 15.8907 81.4848 15.8907C78.5636 15.8571 76.4219 17.9769 76.4062 20.9069Z"
      fill={iconFill}
    />
    <path
      d="M19.1139 26.0266C19.1139 27.3709 19.097 29.9216 19.097 31.4555H16.9891C13.1883 31.4555 9.38764 31.4723 5.58689 31.4555C2.85694 31.4387 0.955962 30.1627 0.282198 27.9567C-0.460146 25.4744 0.247305 23.2863 2.58022 21.8351C4.77477 20.4739 7.14136 19.371 9.42132 18.1466C10.0097 17.8369 10.6317 17.6125 11.1671 17.2344C11.2383 17.1795 11.3022 17.1158 11.3572 17.0448C11.4337 16.9384 11.4801 16.8135 11.4917 16.6832C11.5033 16.5528 11.4795 16.4217 11.423 16.3035C11.3665 16.1855 11.2792 16.0847 11.1702 16.0118C11.0613 15.9387 10.9347 15.8963 10.8037 15.8889H10.7869C7.85001 15.8552 4.89146 15.872 1.94134 15.872H0.627502V10.4287H12.9634C13.5835 10.4339 14.2022 10.4913 14.8127 10.6004C16.6607 10.91 18.0768 11.8415 18.6819 13.6851C19.3389 15.6501 19.0104 17.5633 17.421 18.8909C15.9003 20.1667 14.1377 21.1834 12.428 22.2C10.9939 23.0402 9.47426 23.7173 8.02207 24.5442C7.96637 24.5789 7.91435 24.6191 7.86686 24.6642C7.74919 24.768 7.66565 24.9049 7.62714 25.0568C7.58863 25.2087 7.59695 25.3687 7.65101 25.5159C7.70506 25.663 7.80234 25.7904 7.93015 25.8816C8.05794 25.9727 8.21032 26.0232 8.36737 26.0266L9.08926 26.0434C11.374 26.0782 16.8677 26.0086 19.1139 26.0266Z"
      fill={iconFill}
    />
    <path
      d="M35.9083 10.4963H41.9722C41.9554 10.7364 42.1106 19.8214 41.7473 24.2673C41.4019 28.5416 37.6361 31.6624 33.247 31.9205C29.7928 32.1269 26.596 31.5063 24.1776 28.7312C22.9745 27.3354 22.1731 25.6981 22.1215 23.9061C22.0011 19.465 22.0865 15.0118 22.0865 10.4795H28.047V11.6858C28.0638 15.1667 28.0121 18.6476 28.0818 22.1284C28.1336 25.0092 30.5519 26.6895 33.3168 25.8338C34.8363 25.368 35.8049 24.2301 35.8434 22.593C35.9083 19.0112 35.942 14.0984 35.9083 10.4963Z"
      fill={iconFill}
    />
    <path d="M101.333 31.4551H95.4595V0H101.333V31.4551Z" fill={iconFill} />
  </svg>
);

export const Email = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 0.25H14.25C14.4489 0.25 14.6397 0.329018 14.7803 0.46967C14.921 0.610322 15 0.801088 15 1V13C15 13.1989 14.921 13.3897 14.7803 13.5303C14.6397 13.671 14.4489 13.75 14.25 13.75H0.75C0.551088 13.75 0.360322 13.671 0.21967 13.5303C0.0790176 13.3897 0 13.1989 0 13V1C0 0.801088 0.0790176 0.610322 0.21967 0.46967C0.360322 0.329018 0.551088 0.25 0.75 0.25ZM13.5 3.4285L7.554 8.7535L1.5 3.412V12.25H13.5V3.4285ZM1.88325 1.75L7.54575 6.7465L13.1265 1.75H1.88325Z"
      fill="black"
    />
  </svg>
);

export const UserIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0586 1.66699C7.76109 1.66699 5.89193 3.53616 5.89193 5.83366C5.89193 8.13116 7.76109 10.0003 10.0586 10.0003C12.3561 10.0003 14.2253 8.13116 14.2253 5.83366C14.2253 3.53616 12.3561 1.66699 10.0586 1.66699ZM10.0586 8.33366C8.68026 8.33366 7.55859 7.21199 7.55859 5.83366C7.55859 4.45533 8.68026 3.33366 10.0586 3.33366C11.4369 3.33366 12.5586 4.45533 12.5586 5.83366C12.5586 7.21199 11.4369 8.33366 10.0586 8.33366ZM17.5586 17.5003V16.667C17.5586 13.4512 14.9411 10.8337 11.7253 10.8337H8.39193C5.17526 10.8337 2.55859 13.4512 2.55859 16.667V17.5003H4.22526V16.667C4.22526 14.3695 6.09443 12.5003 8.39193 12.5003H11.7253C14.0228 12.5003 15.8919 14.3695 15.8919 16.667V17.5003H17.5586Z"
      fill="#2E425A"
    />
  </svg>
);

export const UserIconFilled = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 12.502H2.75V11.4395C2.75 10.735 3.02985 10.0593 3.528 9.5612C4.02614 9.06306 4.70177 8.78321 5.40625 8.78321H8.59375C9.29823 8.78321 9.97386 9.06306 10.472 9.5612C10.9701 10.0593 11.25 10.735 11.25 11.4395V12.502ZM7 7.7207C6.58141 7.7207 6.16692 7.63826 5.7802 7.47807C5.39347 7.31788 5.04208 7.08309 4.7461 6.78711C4.45011 6.49112 4.21532 6.13973 4.05513 5.75301C3.89495 5.36628 3.8125 4.95179 3.8125 4.5332C3.8125 4.11462 3.89495 3.70013 4.05513 3.3134C4.21532 2.92667 4.45011 2.57529 4.7461 2.2793C5.04208 1.98331 5.39347 1.74852 5.7802 1.58834C6.16692 1.42815 6.58141 1.3457 7 1.3457C7.84538 1.3457 8.65613 1.68153 9.2539 2.2793C9.85168 2.87707 10.1875 3.68783 10.1875 4.5332C10.1875 5.37858 9.85168 6.18933 9.2539 6.78711C8.65613 7.38488 7.84538 7.7207 7 7.7207Z"
      fill="#ABABAB"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5002 10.1451L16.244 5.40137L17.599 6.75645L12.8553 11.5002L17.599 16.244L16.244 17.599L11.5002 12.8553L6.75645 17.599L5.40137 16.244L10.1451 11.5002L5.40137 6.75645L6.75645 5.40137L11.5002 10.1451Z"
      fill="#131313"
    />
  </svg>
);

export const CheckMark = ({
  color = '#FFFFFF',
  width = '15',
  height = '11',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83312 8.64338L13.4931 0.982544L14.6723 2.16088L5.83312 11L0.529785 5.69671L1.70812 4.51838L5.83312 8.64338Z"
      fill={color}
    />
  </svg>
);

export const ForwardArrow = ({ color = '#FFFFFF' }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0123 6.94597L7.64833 1.58197L9.06233 0.167969L16.8403 7.94597L9.06233 15.724L7.64833 14.31L13.0123 8.94597H0.840332V6.94597H13.0123Z"
      fill={color}
    />
  </svg>
);

export const ArrowLeft = ({ color = '#617D99' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.02341 9.99962L13.1484 14.1246L11.9701 15.303L6.66675 9.99962L11.9701 4.69629L13.1484 5.87462L9.02341 9.99962Z"
      fill={color}
    />
  </svg>
);

export const TicketIcon = ({ color = '#ffffff' }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 2.5C18.221 2.5 18.433 2.5878 18.5893 2.74408C18.7456 2.90036 18.8334 3.11232 18.8334 3.33333V7.91667C18.2808 7.91667 17.7509 8.13616 17.3602 8.52686C16.9695 8.91756 16.75 9.44747 16.75 10C16.75 10.5525 16.9695 11.0824 17.3602 11.4731C17.7509 11.8638 18.2808 12.0833 18.8334 12.0833V16.6667C18.8334 16.8877 18.7456 17.0996 18.5893 17.2559C18.433 17.4122 18.221 17.5 18 17.5H3.00002C2.77901 17.5 2.56704 17.4122 2.41076 17.2559C2.25448 17.0996 2.16669 16.8877 2.16669 16.6667V12.0833C2.71922 12.0833 3.24913 11.8638 3.63983 11.4731C4.03053 11.0824 4.25002 10.5525 4.25002 10C4.25002 9.44747 4.03053 8.91756 3.63983 8.52686C3.24913 8.13616 2.71922 7.91667 2.16669 7.91667V3.33333C2.16669 3.11232 2.25448 2.90036 2.41076 2.74408C2.56704 2.5878 2.77901 2.5 3.00002 2.5H18Z"
      fill={color}
    />
  </svg>
);
